module.exports = __webpack_public_path__ + "static/img/5.1ff0c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/5.jpg
// module id = DZ8Q
// module chunks = 0